
const Month = (props: any) : JSX.Element => {
  return <></>
}
 

export default Month